export type CardPaddingSize = 'none' | 'xs' | 'sm' | 'md' | 'lg'

type CardPaddingAxis = 'horizontal' | 'vertical'
type CardPaddingBreakpoint = 'base' | 'md' | 'lg'

const paddingClasses: Record<
  CardPaddingAxis,
  Record<CardPaddingBreakpoint, Record<CardPaddingSize, string>>
> = {
  horizontal: {
    base: {
      none: 'px-0',
      xs: 'px-2',
      sm: 'px-4',
      md: 'px-6',
      lg: 'px-8',
    },
    md: {
      none: 'md:px-0',
      xs: 'md:px-2',
      sm: 'md:px-4',
      md: 'md:px-6',
      lg: 'md:px-8',
    },
    lg: {
      none: 'lg:px-0',
      xs: 'lg:px-2',
      sm: 'lg:px-4',
      md: 'lg:px-6',
      lg: 'lg:px-8',
    },
  },
  vertical: {
    base: {
      none: 'py-0',
      xs: 'py-2',
      sm: 'py-4',
      md: 'py-6',
      lg: 'py-8',
    },
    md: {
      none: 'md:py-0',
      xs: 'md:py-2',
      sm: 'md:py-4',
      md: 'md:py-6',
      lg: 'md:py-8',
    },
    lg: {
      none: 'lg:py-0',
      xs: 'lg:py-2',
      sm: 'lg:py-4',
      md: 'lg:py-6',
      lg: 'lg:py-8',
    },
  },
}

export const getCardPaddingClass = (
  size: CardPaddingSize | undefined,
  axis: CardPaddingAxis,
  breakpoint: CardPaddingBreakpoint = 'base',
  fallback: CardPaddingSize = axis === 'horizontal' ? 'sm' : 'xs'
) => paddingClasses[axis][breakpoint][size || fallback]
